// export default "http://localhost:8888/panel"
// export default
// http://192.168.0.100:8888/panel
let url = "https://front-api.soroban.ua/api";
// if( window.location.hostname.includes("local") ) url = "http://192.168.0.100:8888/panel"
if (window.location.hostname.includes("local"))
  url = "https://test-web-api.soroban.ua/api";

// if( window.location.hostname.includes("192") ) url = "https://api-test.soroban.ua/panel"
if (window.location.hostname.includes("test"))
  url = "https://test-web-api.soroban.ua/api";
export default url;
